const ipgPay ={
    TITLE:"پرداخت با درگاه بانکی",
    PAYED_BY_CREDIT:" از طریق اعتبار شما پرداخت می‌شود",
    PAY_LIMITED:"حداکثر {percentage} درصد هزینه یک دوره را می‌توان با اعتبار پرداخت کرد",
    TO_PAY:"پرداخت {amount} تومان",
}

export default ipgPay